import { Injectable } from '@angular/core';

export abstract class AgilityRiskPermissionService {

  abstract get canAccessRisk(): boolean;

  abstract get isSuperAdmin(): boolean;

  abstract get isPartner(): boolean;

  abstract get isAdmin(): boolean;

  abstract get isManager(): boolean;

  abstract get isUser(): boolean;

  abstract get isListed(): boolean;

  abstract get hasAdminRoles(): boolean;

  abstract get hasManagerRoles(): boolean;

  abstract canControl(entity: any): boolean;

  abstract canEdit(entity: any): boolean;

  abstract canView(entity: any): boolean;
}

/**
 * This service is just a placeholder that does nothing, in case you don't need a service at all
 */
@Injectable()
export class PermissionDummyService implements AgilityRiskPermissionService {

  get canAccessRisk(): boolean {
    return true;
  }

  get isSuperAdmin(): boolean {
    return true;
  }

  get isPartner(): boolean {
    return true;
  }

  get isAdmin(): boolean {
    return true;
  }

  get isManager(): boolean {
    return true;
  }

  get isUser(): boolean {
    return true;
  }

  get isListed(): boolean {
    return true;
  }

  get hasAdminRoles(): boolean {
    return true;
  }

  get hasManagerRoles(): boolean {
    return this.hasAdminRoles || true;
  }

  canControl(entity: any): boolean {
    return true;
  }

  canEdit(entity: any): boolean {
    return this.canControl(entity) || true;
  }

  canView(entity: any): boolean {
    return this.canEdit(entity) || true;
  }
}
